'use strict';

import Vue from 'vue';
import moment from 'moment';
import {escape} from './utils';

export function escapeHTML(str) {
    const div = document.createElement('DIV');
    div.textContent = str;
    return div.innerHTML;
}

export function initFilters() {
    Vue.filter('money', (value, decimalPlaces = 0, colorize = true) => {
        if (typeof value !== 'number' || isNaN(value)) {
            return '';
        }

        const out = value.toLocaleString('fr-fr', {
            style: 'currency',
            currency: 'EUR',
            currencyDisplay: 'symbol',
            useGrouping: true,
            minimumFractionDigits: decimalPlaces,
            maximumFractionDigits: decimalPlaces
        });

        if (colorize) {
            const cls = (value >= 0) ? 'positive' : 'negative';
            return `<span class="gc-number-${cls}">${out}</span>`;
        } else {
            return out;
        }
    });

    Vue.filter('percent', (value, decimalPlaces = 2) => {
        if (typeof value !== 'number' || isNaN(value)) {
            return '';
        }

        value /= 100;

        return value.toLocaleString('fr-fr', {
            style: 'percent',
            useGrouping: true,
            minimumFractionDigits: decimalPlaces,
            maximumFractionDigits: decimalPlaces
        });
    });

    Vue.filter('shortTitle', (title) => {
        return {
            'monsieur': 'M.',
            'madame': 'Mme.',
            'mademoiselle': 'Mlle.'
        }[title];
    });

    Vue.filter('address', (sourceJson) => {
        try {
            const out = [];
            for (const part of JSON.parse(sourceJson).formatted_address.split(/,\s*/)) {
                out.push(escapeHTML(part));
            }
            return out.join('<br>');
        } catch (e) {
            return escapeHTML(sourceJson);
        }
    });

    Vue.filter('phone', (phoneNumber) => {
        const FRENCH_PREFIX = /^\+33/;

        if (FRENCH_PREFIX.test(phoneNumber)) {
            phoneNumber = phoneNumber.replace(FRENCH_PREFIX, '0');

            if (phoneNumber.length === 10) {
                const out = [];
                let current = '';

                for (const c of phoneNumber) {
                    current += c;

                    if (current.length === 2) {
                        out.push(current);
                        current = '';
                    }
                }

                phoneNumber = out.join('\u00a0');
            }
        }

        return phoneNumber;
    });

    /**
     * Extracts the file name from the URL. Also takes care to remove the
     * query string if any (as most URLs are signed S3 URLs).
     */
    Vue.filter('filename', (path) => {
        return decodeURIComponent(
            path.replace(/^.*\/([^\/?]+)(\?[^\/]*)?$/, '$1')
        );
    });

    Vue.filter('mimeIcon', (mime) => {
        if (!mime) {
            return 'question';
        }

        if (/^image\//.test(mime)) {
            return 'file-image-o';
        }

        if (mime === 'application/pdf') {
            return 'file-pdf-o';
        }

        return 'question';
    });

    Vue.filter('date', (val, format) => {
        return moment(val).format(format);
    });

    Vue.filter('timeFromNow', (val) => {
        return moment(val).fromNow();
    });

    Vue.filter('ucfirst', (str) => {
        if (str.length >= 1) {
            str = str.charAt(0).toLocaleUpperCase() + str.substring(1);
        }

        return str;
    });

    Vue.filter('nl2br', (str) => {
        if (!str) {
            return str;
        }

        console.log(JSON.stringify(str));

        return str.replace('\r\n', '\n').split(/\n{2,}/).map((p) => `<p>${escape(p)}</p>`).join('');
    });

    Vue.filter('makeChunks', (ar, len) => {
        const out = [];
        let cur = [];

        ar.forEach((i) => {
            cur.push(i);

            if (cur.length === len) {
                out.push(cur);
                cur = [];
            }
        });

        if (cur.length) {
            out.push(cur);
        }

        return out;
    });
}



// WEBPACK FOOTER //
// ./src/filters.js